import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2, LogIn } from "lucide-react";
import { toast } from "sonner";

const AdminLogin = () => {
  const { admin, login, loading } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (admin) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(username.trim(), password);
      toast.success("Добро пожаловать");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Не удалось войти");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-180px)] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <div className="label-eyebrow mb-3">Админ-панель</div>
          <h1 className="font-display text-4xl text-[#2C2520]">Вход</h1>
        </div>
        <form
          onSubmit={handleSubmit}
          className="bg-white border border-[#E8E3DA] rounded-[28px] p-8 space-y-5"
        >
          <div>
            <label className="label-eyebrow block mb-2">Логин</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              data-testid="admin-username-input"
              className="w-full px-4 py-3 rounded-2xl border border-[#E8E3DA] bg-white focus:outline-none focus:border-[#C65D3B] text-[#2C2520]"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-2">Пароль</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="w-full px-4 py-3 rounded-2xl border border-[#E8E3DA] bg-white focus:outline-none focus:border-[#C65D3B] text-[#2C2520]"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full justify-center"
            data-testid="admin-login-submit"
          >
            {submitting ? (
              <>
                <Loader2 size={16} className="animate-spin" /> Вход...
              </>
            ) : (
              <>
                <LogIn size={16} /> Войти
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
